/* eslint-disable no-console */

// Registrace service workeru vygenerovaneho pluginem @vue/cli-plugin-pwa
// (GenerateSW mod, viz vue.config.js "pwa" blok) pres oficialni companion
// balicek register-service-worker. Registruje se jen v produkcnim buildu -
// "npm run serve" (NODE_ENV=development) service worker nikdy nezaklada, aby
// se pri vyvoji necachovaly stare verze JS/CSS/HTML.

import { register } from 'register-service-worker'
import { notifyUpdateAvailable } from './config/appUpdate'

// "updated" hook z register-service-worker fire-uje POUZE pri skutecne
// aktualizaci (existuje uz drivejsi navigator.serviceWorker.controller), ne
// pri prvni instalaci - takze neni potreba rucne rozlisovat prvni navstevu appky.
let swRegistration = null

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready (registration) {
      swRegistration = registration
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      swRegistration = registration
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log(`New content is available; please refresh. [${new Date().toISOString()}, controller=${navigator.serviceWorker.controller && navigator.serviceWorker.controller.scriptURL}]`)
      swRegistration = registration
      notifyUpdateAvailable()
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })

  // Na iOS appce pridane na plochu se po navratu z pozadi appka casto jen
  // "probudi" bez skutecne navigace, takze se implicitni prohlizecova
  // kontrola SW updatu vubec nespusti (zname chovani iOS WKWebView) -
  // vynutit kontrolu explicitne pri kazdem navratu appky do popredi.
  const checkForUpdate = () => {
    if (swRegistration) {
      swRegistration.update().catch(() => {})
    }
  }
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkForUpdate()
    }
  })
  window.addEventListener('pageshow', checkForUpdate)
}
